var _desc, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    width: "48px",
    height: "48px",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId,
    stroke: "#2329D6",
    strokeWidth: 1,
    strokeLinecap: "square",
    strokeLinejoin: "miter",
    fill: "none",
    color: "#2329D6",
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "cupIconTitle"
  }, "Trophy") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "cupIconTitle"
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", {
    id: "cupIconDesc"
  }, "Icon of a cup (trophy)")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 2L18 2 18 11C18 14.3137085 15.3137085 17 12 17 8.6862915 17 6 14.3137085 6 11L6 2zM7 21L17 21"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12,17 L12,21"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6 5L6 11 5 11C3.34314575 11 2 9.65685425 2 8 2 6.34314575 3.34314575 5 5 5L6 5zM18 11L18 5 19 5C20.6568542 5 22 6.34314575 22 8 22 9.65685425 20.6568542 11 19 11L18 11z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCup);
export default __webpack_public_path__ + "static/media/cup.ef99d40ba53dc18adc2d5d3d449f1762.svg";
export { ForwardRef as ReactComponent };